import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {PoweredByBlink} from "../../panel-elements/PoweredByBlink.jsx";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {LoginFooter, PromptInlineUserDashboard} from "../../panel-elements/LoginFooter";
import {PanelText} from "../../panel-elements/PanelText.jsx";
import {MakeActionButton, MakeFlowActionButton} from "../../panel-elements/ActionButton";
import {DonationFlowHandler} from "../../flows/DonationFlowHandler.js";
import {PaywallPurchaseFlowHandler} from "../../flows/PaywallPurchaseFlowHandler";
import {AuthFlowHandler} from "../../flows/AuthFlowHandler.js";
import {StyleElement} from "../../../../stem-core/src/ui/StyleElement";
import {NewsletterFlowHandler} from "../../flows/NewsletterFlowHandler.js";
import {PanelCloseButton} from "../../panel-elements/PanelCloseButton.jsx";
import {MerchantLogo} from "../../../common/MerchantLogo";
import {GiftSubscriptionFlowHandler} from "../../flows/GiftSubscriptionFlowHandler.js";
import {convertToUI} from "../../../widget/ui/MessageElement";
import {PanelLink} from "../../panel-elements/PanelLink.jsx";
import {PanelImage} from "../../panel-elements/PanelImage.jsx";
import {BaseFlowHandler} from "../../flows/BaseFlowHandler.js";
import {collapseIframe} from "../../../widget/misc/WidgetUtils.js";
import {authService} from "../../../../client/connection/services/AuthService.js";
import {SubscriptionFlowHandler} from "../../flows/SubscriptionFlowHandler.js";


function MakeLoginFooter(label) {
    return (options, children) => {
        if (authService.isAuthenticated()) {
            return null;
        }
        return <LoginFooter {...options} label={label}>{children}</LoginFooter>;
    }
}

export const panelClassMap = new Map([
    ...[
        "div", "span", "p", "i", "nav",
        "strong", "em", "br", "b", "hr",
        "ul", "ol", "li", "code", "var",
        "h1", "h2", "h3", "h4", "h5", "h6",
        "input", "label",
        "parsererror", // This is to nicely display errors generated by DOMParser.parseFromString.
    ].map(tag => ([tag, UI.Primitive(tag)])),

    ["If", UI.Primitive("div")], // TODO @cleanup what?

    ["Style", StyleElement],
    ["PanelLink", PanelLink], // TODO Duplicate because of our current rendering engine (the DOM)
    ["Link", PanelLink],
    ["PanelImage", PanelImage],
    ["Text", PanelText],
    ["Logo", MerchantLogo],
    ["Close", PanelCloseButton],

    ["SubscribeButton", MakeFlowActionButton(SubscriptionFlowHandler)],
    ["DonateButton", MakeFlowActionButton(DonationFlowHandler)],
    ["GiftSubscriptionButton", MakeFlowActionButton(GiftSubscriptionFlowHandler)],
    ["NewsletterButton", MakeFlowActionButton(NewsletterFlowHandler)],
    ["PurchaseButton", MakeFlowActionButton(PaywallPurchaseFlowHandler, {label: () => PaywallPurchaseFlowHandler.getActionButtonLabel()})],
    ["AuthButton", MakeFlowActionButton(AuthFlowHandler)],

    // TODO @mustfix deprecate this terrible name
    ["IdentityButton", MakeFlowActionButton(AuthFlowHandler)],

    ["LinkButton", MakeFlowActionButton(BaseFlowHandler)],
    ["CloseButton", MakeActionButton({onClick: collapseIframe})],

    ["LoginFooter", MakeLoginFooter()],

    // TODO @mustfix Remove from panels and then from here
    ["SubscribeLoginFooter", MakeLoginFooter("Already a subscriber?")],
    ["DonateLoginFooter", MakeLoginFooter("Already a donor?")],
    ["PurchaseLoginFooter", MakeLoginFooter("Already purchased?")],

    ["PromptInlineUserDashboard", PromptInlineUserDashboard],
    ["PoweredByBlink", PoweredByBlink],
]);

class BasePanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    container = {
        padding: null,
        width: "100%",
    }

    @styleRuleInherit
    content = {
        width: null,
        padding: null
    }
}

@registerStyle(BasePanelStyle)
export class BasePanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            hasHeader: false,
        };
    }

    render() {
        return convertToUI(iFrameState.panelContent, panelClassMap);
    }
}
